import { Link } from "react-router-dom"
import { useState } from "react"
import { Langelement } from "./saleHeader/LangElement"
import "./saleHeader.css"

export function SaleHeader() {
    const languages = {
        eng: { text: "English", flag: "uk.png" },
        fra: { text: "French", flag: "france.png" },
        ar: { text: "Arabic", flag: "arab.png" }
    }

    const [langMenuDisplay, setLangMenuDisplay] = useState(false)
    const [activeLanguage, setActiveLanguage] = useState("eng")

    return (
        <div className="bg-black offer-header-wrapper w-100 d-flex justify-content-center">
            <div className="d-flex offer-header text-white py-2">
                <div className="d-flex">

                    <div className="offer-text text-center">
                        Summer Sale For All Swim Suits And Free Express Delivery - OFF 50%!
                        <Link to="/shop" className="ms-3">Shop Now</Link>
                    </div>

                    <div className="vertical-line"></div>

                    <div className="lang-btn my-auto">
                        <div className="d-flex align-items-center gap-2 text-center"
                            onClick={() => setLangMenuDisplay(!langMenuDisplay)}>
                            <img
                                src={`/images/${languages[activeLanguage].flag}`}
                                width={20}
                                height={15}
                                alt=""
                                className="active-flag md-on"
                            />
                            <div>{languages[activeLanguage].text}</div>
                            <div className="lang-arrow"></div>
                        </div>
                        
                        <div className={
                            langMenuDisplay ? 
                                "position-relative d-flex justify-content-end lang-menu"
                                :
                                "d-none"
                            } onClick={() => setLangMenuDisplay(!langMenuDisplay)}>
                            <div className="position-absolute bg-black">
                                <Langelement
                                    activeLang={activeLanguage}
                                    setActiveLang={setActiveLanguage}
                                    languages={languages}
                                    lang="eng"
                                />
                                <Langelement
                                    activeLang={activeLanguage}
                                    setActiveLang={setActiveLanguage}
                                    languages={languages}
                                    lang="fra"
                                />
                                <Langelement
                                    activeLang={activeLanguage}
                                    setActiveLang={setActiveLanguage}
                                    languages={languages}
                                    lang="ar"
                                />
                            </div>
                        </div>
                        
                    </div>

                    <div className="dummy-div lg-on lg-hid">dummy div for auto height setting</div>
                    
                </div>    
            </div>
        </div>
    )
}